module.exports = __webpack_public_path__ + "img/ic_logo.b3b2c1dc.png";